// extracted by mini-css-extract-plugin
export default {"box":"StackedDevice_box__zKF78"};